import { useTranslation } from 'react-i18next'

import {
  useContentOverflow,
  useDateLocale,
  useTimeZone,
} from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import { FloatingTooltip } from '../../../../Floating'
import {
  RentalPortalApplicantIdentityCell,
  toApplicantTableItem,
} from '../../../../RentalPortalApplicant'
import Text from '../../../../Text'
import { QA_NAME_APPLICANT_BOARD_CARD } from '../../RentalPortalApplicants.constants'

import { getApplicantsBoardCardMeta } from './RentalPortalApplicantsBoardCard.utils'

import * as styles from './RentalPortalApplicantsBoardCard.module.css'

function RentalPortalApplicantsBoardCard({ item, onClick, onMouseDown }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  const timezone = useTimeZone()

  const applicant = toApplicantTableItem(item)

  const metaLabel = getApplicantsBoardCardMeta({
    applicant,
    locale,
    t,
    timezone,
  })

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [metaLabel],
  })

  function handleClick(event) {
    onClick(item.id, event)
  }

  function handleMouseDown(event) {
    onMouseDown(item.id, event)
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_BOARD_CARD })}
      className={styles.RentalPortalApplicantsBoardCard}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
    >
      <RentalPortalApplicantIdentityCell
        applicant={applicant}
        className={styles.identity}
      />
      <FloatingTooltip content={metaLabel} disabled={!overflow}>
        <Text isSecondary className={styles.meta} ref={setContentOverflowRef}>
          {metaLabel}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default RentalPortalApplicantsBoardCard
